import { PageLayout } from '@shared/components/page-layout'
import { PageLayoutOwnProps } from '@shared/components/page-layout/model'
import { Empty } from '@shared/models'
import { NextPageFC } from '@shared/models/next-fc'
import { PagesPath, pagesTitles } from 'data/pages-titles'

import { NewLPScreen } from '../screens/new-lp'

const PersonalPage: NextPageFC<Empty, PageLayoutOwnProps> = () =>
	NewLPScreen({ mainBlockPath: { title: pagesTitles[PagesPath.personal].mainBlockTitle } })

PersonalPage.layout = PageLayout

PersonalPage.headProps = {
	canonicalLink: 'https://credit.club',
	title: pagesTitles[PagesPath.personal].title,
	description:
		'От 200 тысяч рублей ► Конкурентная ставка ► До 2 млн в день обращения ► Без скрытых комиссий и платежей',
	ogImageName: 'graph-loan.png',
}

export default PersonalPage
